import React from 'react';
import { DatabaseIcon } from 'lucide-react';
import { MEMORY_LOOP } from '../../data/platform';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { LoopDiagram } from '../platform/LoopDiagram';

/** Dark subsection: each deal adds to institutional memory that informs the next one. */
export function InstitutionalMemory({
  headingLevel = 'h3'
}: {
  headingLevel?: 'h2' | 'h3';
}) {
  const Heading = headingLevel;
  return <div className="border-t border-night-line bg-night-2" data-id="element-280" data-mp="36xn77tqqqplw">
      <div className="mx-auto grid w-full max-w-[1320px] gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-center lg:gap-16 lg:px-8 lg:py-24" data-id="element-281" data-mp="31x96kwrgyhxw">
        <div data-id="element-282" data-mp="2s7plrlk74e0e">
          {headingLevel === 'h2' ? <SectionHeading tone="dark" eyebrow="Institutional memory" headingId="memory-heading" title="Every Deal Should Make Your Firm Smarter." data-id="element-283" data-mp="2s53fdp91k4jr" /> : <Reveal className="flex flex-col gap-4" data-id="element-284" data-mp="3kutmvfg6486w">
              <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.09em] text-night-muted" data-id="element-285" data-mp="8408vagwgbk7">
                <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-violet" data-id="element-286" data-mp="c4af8o8lt3zl" />
                Institutional memory
              </p>
              <Heading className="sf-display on-dark text-balance text-[28px] leading-[1.05] text-night-text sm:text-[38px] lg:text-[44px]" data-id="element-287" data-mp="3uhi8arlqmk3o">
                Every Deal Should Make Your Firm Smarter.
              </Heading>
            </Reveal>}
          <Reveal delay={0.05} className="mt-6 flex flex-col gap-4 text-[15px] leading-relaxed text-night-muted sm:text-base" data-id="element-288" data-mp="3plb4b4cwjiod">
            <p data-id="element-289" data-mp="3bmbbdkicwhme">
              Investment intelligence is often scattered across emails, spreadsheets, meeting notes, old memos and individual partner memory.
            </p>
            <p className="text-night-text" data-id="element-290" data-mp="19uf3ckvedpwd">DiligenceGPT creates structured institutional knowledge across the entire investment process.</p>
          </Reveal>
        </div>
        <Reveal delay={0.08} data-id="element-291" data-mp="1ce1o78imklxb">
          <LoopDiagram steps={MEMORY_LOOP} tone="dark" ariaLabel="Institutional memory loop" center={<div className="flex flex-col items-center gap-2" data-id="element-293" data-mp="13clnjshm3y6a">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet/15 text-violet-ink" data-id="element-294" data-mp="13d3sddicbkpt">
                  <DatabaseIcon className="h-5 w-5" aria-hidden="true" data-id="element-295" data-mp="yg3mp3pekjz8" />
                </span>
                <p className="text-sm font-semibold text-night-text" data-id="element-296" data-mp="1w3c34kajr2ud">History informs the next deal</p>
                <p className="text-xs text-night-faint" data-id="element-297" data-mp="1r4sgsis1jp1h">Prior memos, decisions and outcomes stay searchable</p>
              </div>} data-id="element-292" data-mp="1cebdetvuip1y" />
        </Reveal>
      </div>
    </div>;
}